import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import Label from '@/components/fields/Label';

export default function RadioField({
  id,
  name,
  children,
  className,
  checked,
  vertical,
}: {
  id: string;
  name: string;
  vertical?: boolean;
  children: ReactNode;
  className?: string;
  checked?: boolean;
}): JSX.Element {
  const { register } = useFormContext();
  const classes = vertical
    ? 'flex flex-col space-y-1 items-center'
    : 'flex items-center my-2 space-x-2';

  return (
    <>
      <div className={`${classes} ${className}`}>
        <input
          id={id}
          name={name}
          type="radio"
          className="form-radio text-primary border-gray-400"
          value={id}
          ref={register}
          defaultChecked={checked}
        />
        <Label id={id} isRequired={false}>
          {children}
        </Label>
      </div>
    </>
  );
}
